import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {reduxForm} from 'redux-form'
import moment from 'moment'
import { DatePicker } from 'components/shared/datePicker'
import Transactions from './clientTransactions'
import styles from './clientFinances.scss'
import {fetchClientFinances, filterClientFinances} from 'state/actions'

import i18n from 'lib/i18n'
const _ = i18n('clientFinances')

const FinForm = reduxForm({
	form: "finances",
	fields: ["startDate", "endDate"],
})((props) => {
	const {
		fields: {startDate, endDate},
		handleSubmit,
		items,
	} = props

	return (
		<div className={styles.clientFinances}>
			<form onSubmit={handleSubmit}>
				<div className={styles.submitContainer}>
					<div className={styles.inputContainer}>
						<div className={styles.label}>
							<p>{_('from')}</p>
						</div>
						<div className={styles.input}>
							<DatePicker {...startDate}/>
						</div>
					</div>
					<div className={styles.inputContainer}>
						<div className={styles.label}>
							<p>{_('till')}</p>
						</div>
						<div className={styles.input}>
							<DatePicker {...endDate}/>
						</div>
					</div>
					<div className={styles.inputContainer}>
						<div className={`${styles.input} ${styles.submit}`}>
							<input type="button" onClick={handleSubmit} value={_('search')}/>
						</div>
					</div>
				</div>
			</form>
			{items &&
				<div className={styles.results}>
					<Transactions items={items}/>
				</div>
			}
		</div>
	)
})

@connect(
	({app, clients}) => {
		const clientId = app.opened
		const items = clients.finances[clientId]
		return {
			clientId,
			items,
			filter: clients.filter,
		}
	},
	{fetchClientFinances, filterClientFinances}
)
export default class Finances extends Component {
	static propTypes = {
		fetchClientFinances: PropTypes.func.isRequired,
		filterClientFinances: PropTypes.func.isRequired,
		clientId: PropTypes.string.isRequired,
		items: PropTypes.array,
		filter: PropTypes.object,
	}

	fetchData() {
		const {fetchClientFinances, clientId, items} = this.props
		if (!items) {
			fetchClientFinances(clientId)
		}
	}
	componentDidMount() {this.fetchData()}
	componentDidUpdate() {this.fetchData()}

	render() {
		const {
			items, filter: {startDate, endDate},
			filterClientFinances,
		} = this.props

		let filteredItems = items
		if (filteredItems && (startDate || endDate)) {
			filteredItems = filteredItems
			.filter(({lineType, transactionDate}) => {
				if (lineType !== 'D' || !transactionDate) {return false}
				const m = moment(transactionDate)
				return (
					(!startDate || m.isSameOrAfter(startDate)) &&
					(!endDate || m.isSameOrBefore(endDate))
				)
			})
		}

		return (
			<FinForm
				items={filteredItems}
				onSubmit={filterClientFinances}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./components/clients/clientFinances.jsx